import { render, staticRenderFns } from "./PauseModal.vue?vue&type=template&id=16bc881c&scoped=true&"
import script from "./PauseModal.vue?vue&type=script&lang=js&"
export * from "./PauseModal.vue?vue&type=script&lang=js&"
import style0 from "./PauseModal.vue?vue&type=style&index=0&id=16bc881c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bc881c",
  null
  
)

export default component.exports